<template>
  <a-upload
      disabled
      list-type="picture-card"
      :file-list="fileList"
      @preview="handlePreview"
      :is-image-url="() => false"
  >
  </a-upload>
  <a-modal
      :footer="null"
      :title="previewTitle"
      v-if="previewVisible"
      :visible="true"
      @cancel="handleCancel"
  >
    <video :src="previewImage" controls style="width: 100%"/>
  </a-modal>
</template>

<script lang="ts" setup>
import {computed, defineProps, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {UploadProps} from "ant-design-vue";
import {tokenManager} from "@/util/token";
import {VideoFieldType} from "@/components/business/crud/interface/FieldType";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: VideoFieldType;
  info: WidgetInfo;
  data: any;
}>();


const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const headers = {
  ...tokenManager.get(),
}

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value =
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const fileList = computed(() => {
  let res: Exclude<UploadProps['fileList'], undefined> = [];
  if (props.data[props.propName]) {
    if (typeof props.data[props.propName] === 'string') {
      res.push({
        uid: props.data[props.propName],
        name: props.data[props.propName],
        status: 'done',
        url: props.data[props.propName],
      });
    } else {
      res = props.data[props.propName].map((item: string) => {
        return {
          uid: item,
          name: item,
          status: 'done',
          url: item,
        };
      });
    }
  }
  return res.concat(...uploadList.value);
})
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}

.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  .img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin: 0 5px 5px 0;
    cursor: pointer;
  }
}
</style>
